import ShareButton from './ShareButton.component';

export default ShareButton;